import React, { useState, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { size as _size } from 'lodash';
import { i18nIntl, formatNumber, isNotEmpty } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';
import { stage_categories as stc } from '../../data/bootstrap_stages';

import ActionLink from '../builder/ActionLink';
import ActionButton from '../builder/ActionButton';

import UserAvatar, { UploadAvatar } from './UserAvatar';
import FloatingLayerPublic from './FloatingLayerPublic';

import UserParticipationsList from './layers/UserParticipationsList';

import XeerpaDiscovery from './XeerpaDiscovery';
import Message from '../builder/Message.js';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';

const MyParticipation = (props) => {
	useCSS('comp/my_participation.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ participation, setParticipation ] = useState(false);
	const [ fb_config, setFbConfig ] = useState( false);
	const [ display_participations, setDisplayParticipations ] = useState(false);
	const [ display_upload_msg, setDisplayUploadMsg ] = useState(false);

	const all_participations = props?.participations ?? false;
	const promotion = props?.promotion?.Promotion ?? false;
	const prizes = props?.prizes ?? [];

	const register_info = all_participations.find((p) => (p.User.stage == 0));
	const participations = all_participations.filter((p) => (p.User.stage != 0));

	const total_played_time = useRef(0);
	participations.map((p) => {
		total_played_time.current += parseFloat(p.User?.time ?? '0');
	});

	const remaining_participations = props?.remaining_participations ?? {};

	const participation_frequencies = [
		{ k:'hour', v:"per hour" },
		{ k:'day', v:"per day" },
		{ k:'total', v:"total" },
	];

	const getStageParticipations = (stage) => {
		const stage_participations = [];
		stage.Stage.participations.map((p) => {
			const user = p.User;
			if(user.score == undefined && isNotEmpty(user, 'quiz_result')) user.score = user.quiz_result;
			user.has_prize = (p.Prize.length > 0) ? true : false;

			stage_participations.push(user);
		});

		return {
			participations:stage_participations,
		};
	};

	const getStagePrizes = (stage) => {
		const _prizes_won = stage.Stage.participations.filter((p) => (p.Prize.length > 0));

		const prizes_won = [];
		_prizes_won.map((prize) => {
			prize.Prize.map((foo, i) => {
				prizes_won.push({
					Prize:prize.Prize[i],
					User:prize.User,
					PromoCode:prize.PromoCode[i],
					CodeValidation:prize?.CodeValidation?.[i] ?? null,
					PrizeType:prizes.filter((p) => (p.id == prize.Prize[i].prize_type)),
				});
			})
		});

		return prizes_won;
	};

	/**
	 * Returns the TOP value among all the participations in the current stage.
	 *
	 * @param  {array}  participations_in_stage group of participations in the current stage
	 * @param  {string} field                   field name within "User" object
	 * @param  {number} direction               set the ordering top definition ("1" for definining the highest value as TOP / "-1" for defining the lowest value as TOP)
	 * @return {number}
	 */
	const calculateMaxValuePerStage = (p) => {
		let return_value = 0;
		if(p.length < 1) return return_value;

		p.map((p) => {
			const participation_value = parseFloat(p.User.quiz_result);
			if(participation_value > return_value) return_value = participation_value;
		});

		return return_value;
	};

	const getBestParticipationInStage = (stage) => {
		if(stage.Stage.participations.length == 0) return false;

		const p = stage.Stage.participations.find((p) => (p.User.quiz_result == stage.Stage.max_value));

		if(p == undefined) return false;

		return (
			<span>
				<strong>{formatNumber(p.User.quiz_result)} {i18n("points")}</strong> {`${i18n("in")} ${formatNumber(p.User.time, 3)} ${i18n("seconds")}`}
			</span>
		);
	};

	const prefillStageData = () => {
		const all_stages = (props.stages != undefined) ? Object.values(props.stages) : [];

		all_stages.map((stage, s) => {
			const stage_id = stage.Stage.id;
			const stage_participations = participations.filter((p) => (p.User.stage == stage_id));

			const _st = {
				...all_stages[s],
				Stage:{
					...all_stages[s].Stage,
					participations:stage_participations,
					max_value:calculateMaxValuePerStage(stage_participations),
				},
			};

			_st.Stage.participations_list = getStageParticipations(_st);
			_st.Stage.best_participation = getBestParticipationInStage(_st);
			_st.Stage.prizes_won_in_stage = getStagePrizes(_st);


			total_played_time.current = 0;
			_st.Stage.participations.map((participation) => {
				total_played_time.current += parseFloat(participation.User.time);
			});
			_st.Stage.total_played_time = total_played_time.current;

			all_stages[s] = _st;
		});

		return all_stages;
	};

	const stages = useRef(prefillStageData());

	const toggleParticipations = () => {
		const new_state = !display_participations;
		
		if(!new_state) {
			setParticipation(false);
			is_stage_a_game = false;
		}

		setDisplayParticipations(new_state);
	};

	const onChangeAvatar = () => {
		setDisplayUploadMsg("The changes may take a few minutes to apply");
	};

	const formatDateTimezone = (date, format = 'll') => {
		return moment.tz(date, 'Europe/Madrid').tz(promotion.timezone).format(format);
	};

	if(promotion === false) return null;

	const displayed_name = (isNotEmpty(register_info.User, 'name')) ? register_info.User.name : `${register_info.User.first_name} ${register_info.User.last_name}`;

	if(fb_config !== false) {
		return (
			<XeerpaDiscovery
				data={fb_config}
				close={() => setFbConfig(false)}
			/>
		)
	}

	const is_unsubscribed = register_info?.User?.unsubscribe_info ?? false;
	const has_avatar = register_info.User?.avatar ?? false;
	const is_visitor = (register_info.User.net_type == 7) ? true : false;
	const is_blocked_avatar = (has_avatar !== false && has_avatar.indexOf('blocked') > -1) ? true : false;
	const total_participations = props?.total_participations ?? 0;
	const total_prizes = props?.total_prizes ?? 0;
	const hide_prizes = promotion?.layout_props?.header?.hide_won_prizes_in_header ?? false;

	return (
		<>
			{(display_upload_msg !== false) && (
				<Message
					title={display_upload_msg}
					_class={{ other:'in_top' }}
					custom_styles={{ '--h2-color':'255, 255, 255, 1' }}
				/>
			)}

			<div class="gui_my_participation gui_main_text_color_on_bg">
				<div class="registration_info">
					<div>
						{(!is_blocked_avatar) ? (
							<UploadAvatar
								onChangeAvatar={onChangeAvatar}
								user={register_info.User}
								width={90}
								height={90}
								display_network_icon={true}
							/>
						) : (
							<UserAvatar
								user={register_info.User}
								width={70}
								height={70}
								display_network_icon={true}
							/>
						)}
					</div>

					<article class="participation_info main_text_flex">
						<LeveledHTMLText
							is_text_block={false}
						>
							<h1 class="full_name">{displayed_name}</h1>

							<p class="relevant_dates">
								<span class="knk-add-user gui_small_icon">
									{i18n("Registered on")}: {formatDateTimezone(register_info.User.created, 'llll')}
								</span>

								{(is_unsubscribed !== false) && (
									<span class="knk-email gui_small_icon">
										{i18n("Unsubscribed on")}: {formatDateTimezone(is_unsubscribed.created, 'll')} (<ActionLink _href={`/emails/resubscribe/${is_unsubscribed.id}/${is_unsubscribed.hash}`} _target="_blank">Subscribe again</ActionLink>)
									</span>
								)}
							</p>
						</LeveledHTMLText>

						<div class="logout">
							<ActionLink
								_href={`/promotions/logout/${promotion.id}`}
								icon='knk-logout'
							>Logout</ActionLink>
						</div>

						{(props.xeerpa && register_info.User.net_type == 1) && (
							<div id="xeerpa_btn" class="solid_buttons">
								<div class="flex_button gui_xeerpa_button gui_custom_color">
									<ActionButton
										icon='ep-facebook'
										_href={`/promotions/my_fb_config/${register_info.User.promotion_id}`}
									>My Facebook Preferences</ActionButton>
								</div>
							</div>
						)}
					</article>
				</div>

				<div class="participations_info">
					{stages.current.map((stage, s) => {
						const is_quiz = ([stc.ID_QUIZ_CATEGORY.id, stc.ID_TIMED_CATEGORY.id].includes(stage.Stage.type)) ? true : false;
						const is_game = ((stage.Stage?.is_game ?? false) || (stage.Stage?.is_new_game ?? false)) ? true : false;
						const is_team = (stage.Stage?.is_team) ? true : false;
						const is_form = (stage.Stage?.is_form) ? true : false;

						let pf = participation_frequencies.filter((f) => (f.k == stage.Stage.participation_frequency));
						pf = (pf.length > 0) ? pf[0].v : "total";

						return (
							<div class="stage_info" key={`stage_${stage.Stage.id}`}>
								{(stages.current.length > 1) && (
									<h3 class="in_bottom">Stage #{s + 1}</h3>
								)}

								<LeveledHTMLText
									_class={{ other:'stage_main_info' }}
								>
									{(is_game && (stage.Stage.participations.length == 0 || stage.Stage.best_participation === false)) && (
										<p class="participation_frequency without_participations">
											{(stages.current.length == 1) ? (
												<span>{i18n("You have not participated yet.")}</span>
											) : (
												<span>{i18n("You have not participated here yet.")}</span>
											)}

											{(remaining_participations.retries != undefined && remaining_participations.next_participation === true) && (
												<strong class="gui_not_in_start_small">
													<ActionLink
														_href={`/promotions/participate/${promotion.id}`}
													>Play now</ActionLink>
												</strong>
											)}
										</p>
									)}
								</LeveledHTMLText>

								<div
									dangerouslySetInnerHTML={{
										__html:`${i18n("Total participations")}: <strong>${total_participations}</strong>`,
									}}
								/>

								{(prizes.length > 0 && !hide_prizes && !is_visitor) && (
									<p><ActionLink _href={`/my_prizes/${promotion.id}`}>View my prizes</ActionLink> ({total_prizes})</p>
								)}

								{(stage.Stage.participations.length > 0 || stage.Stage.best_participation === false) && (
									<UserParticipationsList
										stage={stage.Stage}
										participations={stage.Stage.participations_list.participations}
										is_game={is_game}
										is_quiz={is_quiz}
										is_team={is_team}
										is_form={is_form}
										promotion={promotion}
										total_participations={props.total_participations}
										stages={stages.current}
										username={displayed_name}
										locale={props.locale}
									/>
								)}
							</div>
						)
					})}

					{(display_participations && participation) && (
						<FloatingLayerPublic
							pm={promotion}
							title={`<h1>${displayed_name}</h1><p>${participation.participations.length} ${i18n("participations")}</p>`}
							backButton={() => toggleParticipations()}
						>
							<UserParticipationsList
								participations={participation.participations}
								is_game={false}
								is_quiz={is_quiz && has_public_quiz_stats}
								is_team={is_team}
								is_form={is_form}
								promotion={promotion}
								stages={stages.current}
								username={displayed_name}
								locale={props.locale}
							/>
						</FloatingLayerPublic>
					)}
				</div>
			</div>
		</>
	);
};

export default injectIntl(MyParticipation);